import { Injectable } from '@angular/core';

/**
 * Guarded access to browser sessionStorage. Session lifecycle belongs to SessionManagerService.
 */
@Injectable({ providedIn: 'root' })
export class SessionStorageService {
	public read<T>(key: string): T | undefined {
		try {
			const raw = sessionStorage.getItem(key);
			return raw ? (JSON.parse(raw) as T) : undefined;
		} catch {
			return undefined;
		}
	}

	public write(key: string, value: unknown): boolean {
		try {
			sessionStorage.setItem(key, JSON.stringify(value));
			return true;
		} catch {
			return false;
		}
	}

	public remove(key: string): boolean {
		try {
			sessionStorage.removeItem(key);
			return true;
		} catch {
			return false;
		}
	}

	/** Removes every entry whose key starts with the prefix. Returns false when browser storage rejects the operation. */
	public removeByPrefix(prefix: string): boolean {
		try {
			const keys: string[] = [];
			for (let index = 0; index < sessionStorage.length; index++) {
				const key = sessionStorage.key(index);
				if (key?.startsWith(prefix)) keys.push(key);
			}
			keys.forEach((key) => sessionStorage.removeItem(key));
			return true;
		} catch {
			return false;
		}
	}
}
